import { Controller } from "@hotwired/stimulus"

export default class CoreuiToastControlController extends Controller {
  static outlets = ["coreui-toast"]

  show(event) {
    this.coreuiToastOutlets.forEach((owner) => owner.show(event))
  }

  hide() {
    this.coreuiToastOutlets.forEach((owner) => owner.hide())
  }
}
